import Page from "./page.reports.page";
import LoggedIn from "../../layouts/loggedIn.layout";
import { ROIsProvider } from "../../contexts/rois/rois.context";
import { ReportsProvider } from "../../contexts/reports/reports.context";
const ReportsLayout = () => {
  return (
    <LoggedIn>
      <ROIsProvider>
        <ReportsProvider>
          <Page />
        </ReportsProvider>
      </ROIsProvider>
    </LoggedIn>
  );
};

export default ReportsLayout;
